import LocalizedStrings from "react-localization";

const Reports = () => {
    return (
      <div>
          <span><h1>{strings.title}</h1></span>
          <span><h3>Modulo no disponible</h3></span>
      </div>
    )
}

const strings = new LocalizedStrings({
    es:{
        title: "Reportes"
    },
});

export default Reports;